import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { WfTaskLocalResource } from 'src/app/components/workflow/workflow';
import { SignResource } from 'src/app/services/logs/signs';
import { TransactionLog } from 'src/app/services/logs/transaction-logs';

@Component({
  selector: 'transaction-log-approvals',
  templateUrl: './transaction-log-approvals.component.html',
  styleUrls: ['./transaction-log-approvals.component.scss']
})
export class TransactionLogApprovalsComponent extends BaseComponent implements OnChanges {

  @Input() transactionLogs?: TransactionLog[];

  signLogs?: SignResource[] = [];
  showBoxes?: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    this.createSignLogs();
  }

  createSignLogs() {
    this.signLogs = [];
    this.transactionLogs?.filter(t => t.entityName == 'WFTask')?.map(t => {
      const wfTask = this.utils.JSONparse(t.objectJson);
      const signLog = {
        name: wfTask.Name ?? wfTask.name,
        signedBy: wfTask.SignedBy ?? wfTask.signedBy,
        signedOn: wfTask.SignedOn ?? wfTask.signedOn,
        amendmentId: wfTask.AmendmentId ?? wfTask.amendmentId,
        reason: wfTask.Reason ?? wfTask.reason,
        roleName: wfTask.RoleName ?? wfTask.roleName
      } as SignResource;
      this.signLogs?.push(signLog);
    });
  }
}
